<!--
 * @Description: 弹窗组件
 * @Author: mdb
 * @Date: 2022-11-03 15:46:54
 * @LastEditTime: 2022-11-29 14:39:55
 * @LastEditors: mdb
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :title="title"
    width="670px"
    :confirm-loading="loading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="dataForm" ref="formRef" :rules="formRules" :wrapper-col="{ span: 24 }">
      <dc-form-item name="paramId" label="国家" :span="24">
        <ParamCodesSelect
          v-model:value="dataForm.paramId"
          :options="paramCodeFormat.lbu_demand_country"
          placeholder="请选择国家"
          allowClear
        />
      </dc-form-item>
      <dc-form-item name="paramRefIdList" label="云途产品" :span="24">
        <ParamCodeCascader
          v-model:value="dataForm.paramRefIdList"
          :options="paramCodeFormat.lbu_products"
          placeholder="请选择云途产品"
          multiple
          allowClear
        />
      </dc-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { cloneDeep } from 'lodash-es'
import { message as DcMessage } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { selectForNumberValidate } from '@/utils/validate'
import { countryChannelSave } from '@/api/yuntuSales/operationsManage'
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import type { ParamCodeItem } from '@/typings/common'

interface CountryChannelParams {
  paramId: number
  paramRefIdList: number[]
}
interface ParamCodeFormatItem extends ParamCodeItem {
  disabled?: boolean
}

const props = defineProps<{
  paramCodeData: { [key: string]: ParamCodeFormatItem[] }
}>()

const title = ref<string>()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const initForm = { paramId: -9, paramRefIdList: [] }
const dataForm = ref<CountryChannelParams>(cloneDeep(initForm))
const formRules: Record<string, Rule[]> = {
  paramId: [{ required: true, validator: selectForNumberValidate, message: '请选择国家' }],
  paramRefIdList: [{ required: true, message: '请选择云途产品' }]
}

watch(
  () => visible.value,
  (val) => {
    if (!val) {
      formRef.value?.resetFields()
      dataForm.value = cloneDeep(initForm)
    }
  }
)

const paramCodeFormat = ref<{ [key: string]: ParamCodeFormatItem[] }>({})
const init = (countryList: number[], data: any) => {
  paramCodeFormat.value = cloneDeep(props.paramCodeData)
  if (data) {
    title.value = '编辑'
    dataForm.value.paramId = data.paramId
    dataForm.value.paramRefIdList = data.paramRefIdList
    const find = countryList.findIndex((item) => item === data.paramId)
    find && countryList.splice(find, 1)
  } else {
    title.value = '新增'
  }
  paramCodeFormat.value.lbu_demand_country.forEach((item) => {
    item.disabled = countryList.includes(item.id as number)
  })
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const params = Object.assign({}, dataForm.value)
    countryChannelSave(params)
      .then(() => {
        DcMessage.success(`${title.value}成功`)
        formRef.value?.resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleCancel = () => {
  formRef.value?.resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'CountryChannelModal' }
</script>

<style lang="scss" scoped></style>
